import { createFileRoute, notFound } from '@tanstack/react-router';
import { RouteName, TextKey } from '@mews-commander/enums';
import { CityLedgerPage } from '@mews-commander/modules/src/modules/finance';
import { MewsTeam, RouteType } from '@mews/enums';
import { lt } from '@mews/framework';
import { ErrorHandler } from '@mews-commander/ui';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Finance/Ledgers/City')({
    component: CityLedgerPage,
    notFoundComponent: () => <NotFoundComponent />,
    loader: async ({ context: { ensureQueryData } }) => {
        const data = await ensureQueryData('accountingConfigurations', 'get', {});
        const isNewCityLedgerEnabled = !!data?.accountingConfiguration?.options?.receivableTrackingEnabled;

        if (!isNewCityLedgerEnabled) {
            throw notFound();
        }
    },

    staticData: {
        owner: MewsTeam.Accounting,
        type: RouteType.Frontend,
        title: TextKey.CityLedger,
        routeName: RouteName.FinanceCityLedger,
    },
});

const NotFoundComponent = () => (
    <ErrorHandler errorMessage={lt('PageNotFoundErrorMessage')} errorTitle={lt('PageNotFoundTitle')} />
);
